import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {RoomClientState} from '../../../../shared/scripts/RoomClientState.ts'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {setElementInnerHTML, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIRoomCenterShareLinkController {
    private readonly gameSettingsTitle: HTMLHeadingElement
    private readonly link: HTMLDivElement
    private readonly linkButton: HTMLLinkElement

    constructor() {
        this.gameSettingsTitle = document.getElementById('room_center_game_settings_title') as HTMLHeadingElement
        this.link = document.getElementById('room_center_link') as HTMLInputElement
        this.linkButton = document.getElementById('room_center_link_button') as HTMLLinkElement
    }

    load(roomState: RoomClientState) {
        if(this.link == undefined) return

        this.gameSettingsTitle.addEventListener('copy', () => {
            const selectedText = window.getSelection()?.toString()
            if(selectedText?.includes(roomState.gameSetting.id)) void this.sendCopyLinkEvent(roomState.gameSetting.id)
        })

        const linkText = `${window.location.origin}/${window.location.hash}`.toLocaleLowerCase()

        setElementInnerHTML(this.link, {key: 'strings:colonistCommon.utils.#buffer', options: {value: linkText}})
        this.link.addEventListener('copy', () => this.sendCopyLinkEvent(roomState.gameSetting.id))

        setElementInnerHTML(this.linkButton, {key: 'strings:roomPage.options.inviteFriends.copy'})
        setElementOnClick(this.linkButton, () => {
            AudioManager.play(AudioType.Click)
            void navigator.clipboard.writeText(linkText)
            setElementInnerHTML(this.linkButton, {key: 'strings:roomPage.copiedLink'})
            setTimeout(() => {
                setElementInnerHTML(this.linkButton, {key: 'strings:roomPage.options.inviteFriends.copy'})
            }, 1500)
            void this.sendCopyLinkEvent(roomState.gameSetting.id)
        })
    }

    // eslint-disable-next-line class-methods-use-this
    private async sendCopyLinkEvent(roomId: string) {
        const copyLinkEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.CopiedRoomLink,
            category: AnalyticEventCategory.Lobby,
            stringValue: roomId,
        }
        void CA.sendAnalyticEventOnce(copyLinkEvent)
    }
}
